export function toUpperCase(stringItem: string) {
	return stringItem?.toUpperCase();
}
